interface Props {
  title?: string
  description?: string
}

function Item({ title, description }: Props) {
  return (
    <li className='border-b last:border-b-0 border-dotted border-c-beige-900 lg:border-b-0 lg:border-l pl-6 flex flex-col items-start pb-5 lg:pb-0 text-balance lg:grid lg:grid-rows-subgrid lg:row-span-2'>
      <h2 className='mb-3 c-body-bold lg:mb-0'>{title}</h2>
      <p className='text-c-text-tint-2 c-body max-w-[30ch]'>{description}</p>
    </li>
  )
}
export default Item
